import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { User } from '../core/user';
import { Campaign, RecipientCampaignsResponse } from '../marketing/campaign';
import { CampaignDialogStoreService } from './campaign-dialog-store.service';

@Component({
  styleUrls: ['./campaigns-dialog.component.scss'],
  template: `
    <div mat-dialog-title>
      Campaigns
      <div class="campaigns-dialog-subheader">
        <p>
          Campaigns available for
          <b>{{ userName }}</b>
        </p>
        <div class="search-field">
          <mat-form-field>
            <input matInput [formControl]="searchTerm" placeholder="Search" (input)="updateSearchTerm()" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <mat-dialog-content>
      <ng-container *ngFor="let campaign of campaigns$ | async">
        <app-campaign-dialog-item
          [campaign]="campaign"
          [userId]="userId"
          [accountGroupId]="accountGroupId"
          [marketId]="marketId"
        ></app-campaign-dialog-item>
      </ng-container>
      <div class="action-content" *ngIf="loadingCampaigns$ | async">
        <mat-spinner [diameter]="30" [strokeWidth]="4"></mat-spinner>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="close-button">
      <button mat-button (click)="dialogRef.close()" class="close-button__button">Close</button>
    </mat-dialog-actions>
  `,
  standalone: false,
})
export class CampaignsDialogComponent implements OnInit {
  @Input() partnerId: string;
  @Input() accountGroupId: string;
  @Input() marketId: string;
  @Input() set user(u: User) {
    this.userName = this.getUserNameOrEmailText(u);
    this.userEmail = u.email;
    this.userId = u.userId;
  }

  userName: string;
  userEmail: string;
  userId: string;
  campaigns$: Observable<Campaign[]>;
  loadingCampaigns$: Observable<boolean>;
  recipientCampaigns$: Observable<RecipientCampaignsResponse>;
  searchTerm = new UntypedFormControl('');
  lastSearchTerm = '';

  constructor(
    public dialogRef: MatDialogRef<CampaignsDialogComponent>,
    private campaignDialogStoreService: CampaignDialogStoreService,
  ) {}

  ngOnInit(): void {
    this.campaigns$ = this.campaignDialogStoreService.campaigns$;
    this.loadingCampaigns$ = this.campaignDialogStoreService.loadingCampaigns$;
    this.recipientCampaigns$ = this.campaignDialogStoreService.recipientCampaigns$;
    this.campaignDialogStoreService.init(this.partnerId, this.accountGroupId, this.userEmail);
    this.campaignDialogStoreService.updateSearch(this.searchTerm.value);
  }

  private getUserNameOrEmailText(user: User): string {
    if (user.firstName && user.lastName) {
      return user.firstName + ' ' + user.lastName;
    } else if (user.firstName && !user.lastName) {
      return user.firstName;
    } else {
      return user.email;
    }
  }

  updateSearchTerm(): void {
    if (this.searchTerm.value === this.lastSearchTerm) {
      return;
    }
    this.lastSearchTerm = this.searchTerm.value;
    this.campaignDialogStoreService.updateSearch(this.searchTerm.value);
  }

  loadMore(): void {
    this.campaignDialogStoreService.updateSearch(this.searchTerm.value);
  }
}
